import { useGetLaboratoryUserQuery } from "@/api/LaboratoryUsersApi";
import { Stack } from "@mui/material";
import { createFileRoute } from "@tanstack/react-router";
import Loader from "@components/Loader.tsx";
import AppCard from "@components/AppCard.tsx";
import SinglePersonForm from "@components/annuaire/people/form/SinglePersonForm.tsx";
import PersonPasswordUpdateForm from "@components/annuaire/people/form/PersonPasswordUpdateForm.tsx";
import { requireRole } from "@/auth/requireRole.ts";
import { ROLE_ADMIN } from "@/constants";

export const Route = createFileRoute("/_dashboard/annuaire/people/$uuid")({
  beforeLoad: (args) => {
    requireRole([ROLE_ADMIN])(args);
  },
  component: PersonDetailsPage,
});

function PersonDetailsPage() {
  const { uuid } = Route.useParams();
  const { data: person, isLoading } = useGetLaboratoryUserQuery(uuid);

  const handleGoBack = () => {
    window.history.back();
  };

  if (isLoading)
    return (
      <Stack justifyContent={"center"} alignItems={"center"}>
        <Loader />
      </Stack>
    );
  if (!person) return null;

  return (
    <Stack gap={4}>
      <AppCard>
        <SinglePersonForm
          type={"update"}
          laboratoryUser={person}
          onCancel={handleGoBack}
          onSuccess={() => {}}
        />
      </AppCard>
      <AppCard>
        <PersonPasswordUpdateForm laboratoryUser={person} />
      </AppCard>
    </Stack>
  );
}
